import * as ActionTypes from '../ActionTypes';

const initialState = {
    subBusinessunitData: [],
    isLoading: false,
};

const SubBusinessUnitReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SUB_BUSINESSUNIT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                subBusinessunitData: "",
            };
        case ActionTypes.SUB_BUSINESSUNIT_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                isLoading: false,
                subBusinessunitData: action.payload?.data?.data
            };
        case ActionTypes.SUB_BUSINESSUNIT_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.SUB_BUSINESSUNIT_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                subBusinessunitData: action.payload?.data?.data
            };
        case ActionTypes.SUB_BUSINESSUNIT_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.SUB_BUSINESSUNIT_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.SUB_BUSINESSUNIT_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                subBusinessunitData: action.payload?.data?.data
            };
        case ActionTypes.SUB_BUSINESSUNIT_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.SUB_BUSINESSUNIT_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.SUB_BUSINESSUNIT_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                subBusinessunitData: action.payload?.data?.data
            };
        case ActionTypes.SUB_BUSINESSUNIT_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default SubBusinessUnitReducer;